import React from 'react'
import { useTranslation } from 'react-i18next'

import toolkitLogo from '@assets/images/toolkit-logo-light.png'

import { usePlatformDetection } from '@utils/hooks'

import { BottomSheet } from '@components/BottomSheet/BottomSheet.component'

import {
  Footer,
  ImgLogo,
  DownloadButton,
  StayButton,
  UpdateContainer,
  UpdateDescription,
  UpdateTitle,
  LogoContainer,
  BodyContainer,
} from './BottomSheetCheckDownloadApp.styled'

interface BottomSheetCheckDownloadAppProps {
  open: boolean
  onDismiss: () => void
}

export const BottomSheetCheckDownloadApp: React.FC<BottomSheetCheckDownloadAppProps> = ({ open, onDismiss }) => {
  const { isAndroid, isIOS } = usePlatformDetection()
  const { t } = useTranslation()

  const appId = isIOS ? import.meta.env.VITE_IOS_APP_ID : import.meta.env.VITE_ANDROID_APP_ID

  const href = isIOS
    ? `https://apps.apple.com/app/${appId}`
    : isAndroid
    ? `https://play.google.com/store/apps/details?id=${appId}`
    : undefined

  return (
    <BottomSheet
      open={open}
      onDismiss={onDismiss}
      minHeight="300px"
      snapPoints={({ maxHeight }: { maxHeight: number }) => [Math.min(400, maxHeight * 0.8)]}
    >
      <UpdateContainer>
        <LogoContainer>
          <ImgLogo src={toolkitLogo} />
        </LogoContainer>

        <BodyContainer>
          <UpdateTitle>{t('modules_main_components_BottomSheetCheckDownloadApp_title')}</UpdateTitle>

          <UpdateDescription>{t('modules_main_components_BottomSheetCheckDownloadApp_desc')}</UpdateDescription>
        </BodyContainer>

        <Footer>
          <StayButton onClick={onDismiss} type="button">
            {t('modules_main_components_BottomSheetCheckDownloadApp_button_stay_label')}
          </StayButton>

          <DownloadButton href={href} target="_blank" type="button" onClick={onDismiss}>
            {t('modules_main_components_BottomSheetCheckDownloadApp_button_download_label')}
          </DownloadButton>
        </Footer>
      </UpdateContainer>
    </BottomSheet>
  )
}
